<template>
  <div class="header">
    <div class="w clearfix">
      <div class="logo">
        <a href="/cn" title="依图科技" rel="home" id="logo">
          <img src="https://www.yitutech.com/sites/all/themes/yitu/images/logo.svg" alt="依图科技" />
        </a>
      </div>

      <div class="nav">
        <div
          id="block-system-main-menu"
          class="block block-system block-menu sub-nav-item"
        >
          <ul class="menu clearfix">
            <li class="first leaf"><a href="https://www.yitutech.com/cn">首页</a></li>
            <li class="expanded">
              <a href="https://www.yitutech.com/cn/business/ai-city">核心业务</a>
            </li>
            <li class="leaf"><a href="https://www.yitutech.com/cn/cases">行业实践</a></li>
            <li class="leaf">
              <a
                href="https://speech.yitutech.com/"
                class="speech"
                target="_blank"
                >开放平台</a
              >
            </li>
            <li class="leaf"><a href="https://www.yitutech.com/cn/news">新闻中心</a></li>
            <li class="leaf"><a href="https://www.yitutech.com/cn/about-us">关于我们</a></li>
            <li class="leaf"><a href="https://www.yitutech.com/cn/join-us">加入依图</a></li>
            <li class="leaf">
              <a href="http://partner.yitutech.com/" class="hzhb">合作伙伴</a>
            </li>
            <li class="last leaf active-trail">
              <a href="https://www.yitutech.com/cn/service" class="active-trail">支持与服务</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- <div class="header-right">
        <div id="block-block-19" class="block block-block">
          <div class="btn-blue apply-btn">
            <a href="javascript:;">业务咨询</a>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'tecHeader',
};
</script>

<style scoped>


.header {
  width: 100%;
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  background: rgba(0,0,0,0.1);
  border-bottom: 1px solid rgba(255,255,255,0.20);
}

body.fixed .header {
  transform: translate3d(0,-60px,0);
}

body.slide-in .header {
  animation: headerIn 0.5s ease both;
}

body.fixed .header {
  transform: translate3d(0,-60px,0);
}

body.slide-in .header {
  animation: headerIn 0.5s ease both;
}

body.toolbar .header {
  top: 30px;
}

body.toolbar.slide-in .header {
  animation: none;
}

@keyframes headerIn {
  from {
      transform: translate3d(0,-60px,0);
  }

  to {
      transform: translate3d(0,0,0);
  }
}

body.has-top-banner .header {
  background: #08061E;
}

.header-right {
  float: right;
  position: relative;
}

.header .btn-blue {
  height: 60px;
  float: right;
  width: 124px;
  line-height: 60px;
}

.header .btn-blue a {
  line-height: 60px;
}

.logo {
  width: 121px;
  height: 100%;
  padding: 20px 0;
  float: left;
  margin-right: 30px;
}

.logo img {
  width: 100%;
  float: left;
}

.nav {
  float: left;
  height: 100%;
  width: calc(100% - 282px);
}

ul.menu li.leaf {
  margin: 0;
  padding: 0;
  list-style: none;
  height: auto;
}

.nav .block-menu {
  float: left;
}

.nav .block-menu > ul > li {
  color: rgba(255,255,255,0.7);
  cursor: pointer;
  margin-right: 14px;
  padding: 0 8px;
  float: left;
}

.en .nav .block-menu > ul > li {
  margin-right: 10px;
}

.nav .block-menu > ul > li.expanded {
  transition: all 0.5s;
  position: relative;
  padding-top: 0;
  list-style: none;
  margin-left: 0;
}

.nav .block-menu > ul > li a {
  color: #fff;
  opacity: 0.7;
  font-size: 14px;
  line-height: 60px;
  transition: all 0.3s;
  position: relative;
}

.nav .block-menu > ul > li.expanded:hover {
  background-color: #080827;
}

.nav .block-menu > ul > li a.active,.nav .block-menu > ul > li.active-trail > a,.nav .block-menu > ul > li:hover > a,.nav .block-menu > ul > li > a.active-trail {
  opacity: 1;
}

.nav .block-menu > ul > li > ul {
  display: block;
  width: 190px;
  background: #080827;
  position: absolute;
  top: 59px;
  left: 0;
  padding: 0 8px 0 18px;
  display: none;
}

.nav .block-menu > ul > li.expanded:hover > ul {
  display: block;
  animation: slideDown 0.3s ease-in-out both;
}

.btn-blue {
  background: #0D579F;
  color: #fff;
  display: inline-block;
  text-align: center;
  transition: all 0.5s;
}

.btn-blue:hover {
  color: #166BBE;
}

.btn-blue a {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 14px;
  text-align: center;
}

.header .btn-blue {
  height: 60px;
  float: right;
  width: 124px;
  line-height: 60px;
}

.header .btn-blue a {
  line-height: 60px;
}

.w {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;
}

.flex {
  display: flex;
}

.flex-v {
  flex-direction: column;
  justify-content: center;
}
</style>
